document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.custom-atc-form').forEach(form => {
    const minus = form.querySelector('.qty-btn.minus');
    const plus = form.querySelector('.qty-btn.plus');
    const input = form.querySelector('.qty-input');

    if (minus && plus && input) {
      minus.addEventListener('click', () => {
        let current = parseInt(input.value);
        if (current > 1) input.value = current - 1;
      });

      plus.addEventListener('click', () => {
        input.value = parseInt(input.value) + 1;
      });
    }
  });
});
